import Vue from 'vue';
import VueSlider from 'vue-slider-component';

const id = 'bmi_calculator';

const BMICalculator = {
	Init() {
		/* eslint-disable */
		if (document.getElementById(id)) {
			new Vue({
				el: `#${id}`,
				components: {
					VueSlider
				},
				data: {
					bmi: null,
					bmiCategory: 'default',
					heightOptions: {
						dotSize: 44,
						height: null,
						tooltipFormatter: val => `${Math.floor(val / 12)}' ${val - ((Math.floor(val / 12)) * 12)}"`,
						value: 68
					},
					weightOptions: {
						dotSize: 44,
						tooltipFormatter: '{value}lbs.',
						value: 150
					}
				},
				methods: {
					calculateBMI() {
						let height = this.$refs.sliderHeight.getValue();
						let weight = this.$refs.sliderWeight.getValue();
						this.bmi = Math.floor((weight / (height * height)) * 703);
						this.setCategory(this.bmi);
						document.getElementById('bmi_hidden').value = this.bmi;
					},
					setCategory(bmi) {
						if (bmi < 18.5) {
							return this.bmiCategory = 'underweight';
						} else if (bmi < 25) {
							return this.bmiCategory = 'normal';
						} else if (bmi < 30) {
							return this.bmiCategory = 'overweight';
						} else {
							return this.bmiCategory = 'obese';
						}
					}
				},
			});
		};
		/* eslint-enable */
	}
};

export default BMICalculator;
